export default __webpack_public_path__ + "static/media/updown.b8d437a8.svg";